import React from 'react';
import { ChevronLeft } from 'lucide-react';

const MenuPageShell = ({ title, icon: Icon, children, onBack }) => (
  <div style={{ minHeight:'100vh', background:'#f8fafc', paddingBottom:120 }}>
    <div style={{ background:'linear-gradient(135deg,#0f172a,#1e3a5f)', padding:'28px 20px 24px' }}>
      <button onClick={onBack}
        style={{ background:'rgba(255,255,255,0.1)', border:'none', color:'rgba(255,255,255,0.8)', borderRadius:10, padding:'6px 12px', fontSize:12, fontWeight:700, cursor:'pointer', marginBottom:16, display:'flex', alignItems:'center', gap:6 }}>
        <ChevronLeft size={14}/> 返回
      </button>
      <div style={{ display:'flex', alignItems:'center', gap:14 }}>
        <div style={{ width:48, height:48, borderRadius:16, background:'rgba(245,158,11,0.2)', display:'flex', alignItems:'center', justifyContent:'center' }}>
          <Icon size={24} color='#f59e0b'/>
        </div>
        <h1 style={{ margin:0, color:'#fff', fontSize:24, fontWeight:900, letterSpacing:-0.5 }}>{title}</h1>
      </div>
    </div>
    <div style={{ maxWidth:720, margin:'0 auto', padding:'24px 16px' }}>{children}</div>
  </div>
);

export default MenuPageShell;
